module.exports = __webpack_public_path__ + "static/img/skdzz-logo.d06a9fe4.png";